import { useState } from "react";
import { Form, InputGroup, Modal } from "react-bootstrap";
import { SubmitButton, CancelButton } from "../../shared";

export function AgentAdjustmentModal({
  agentLabel,
  initial,
  onCancel,
  onSave,
  isSubmitting,
}) {
  const [amount, setAmount] = useState(
    initial ? String(initial.adjustmentAmount ?? "") : "",
  );
  const [reason, setReason] = useState(initial?.reason ?? "");
  const parsed = parseFloat(amount);
  const valid = !isNaN(parsed) && reason.trim().length > 0;
  const isEditing = Boolean(initial);

  return (
    <Modal show onHide={onCancel} centered className="commission-modal-scope">
      <Modal.Header closeButton>
        <Modal.Title className="fs-6">
          {isEditing ? "Edit agent adjustment" : "Add agent adjustment"} -{" "}
          {agentLabel}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label className="field-label">
            Amount <span className="text-danger">*</span>
          </Form.Label>
          <InputGroup>
            <InputGroup.Text>$</InputGroup.Text>
            <Form.Control
              type="number"
              step="0.01"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="Enter positive or negative amount"
              disabled={isSubmitting}
              autoFocus
            />
          </InputGroup>
          <Form.Text className="text-muted">
            Use a negative amount for deductions.
          </Form.Text>
        </Form.Group>

        <Form.Group>
          <Form.Label className="field-label">
            Reason <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            maxLength={500}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Why is this adjustment being added?"
            disabled={isSubmitting}
          />
          <Form.Text className="char-counter">{reason.length}/500</Form.Text>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <CancelButton onClick={onCancel} disabled={isSubmitting} />
        <SubmitButton
          text={isEditing ? "Save changes" : "Save adjustment"}
          color="blue"
          disabled={!valid}
          isSubmitting={isSubmitting}
          onClick={() => onSave(parsed, reason.trim())}
        />
      </Modal.Footer>
    </Modal>
  );
}
